/* eslint-disable no-bitwise */
import * as React from "react";
import * as Survey from "survey-react";

import { PersonRequest } from "@plinknz/tah-website-elements";

import { BenefitForm } from "./benefit-form";
import { CustomerFormQuestionTypes } from "./customer-form-types";
import { createSurveyConfig } from "../../../service/forms/putea-tautoko-survey-config";
import { transformPuteaTautokoData } from "../../../utility/form-transforms/transform-putea-tautoko-data";

export const PuteaTautokoForm = () => {
  const transformData = (
    survey: Survey.ReactSurveyModel,
    member: PersonRequest
  ) => {
    return transformPuteaTautokoData(survey, member);
  };

  return (
    <BenefitForm
      createSurveyConfig={createSurveyConfig}
      transformData={transformData}
      questionTypes={
        CustomerFormQuestionTypes.AddressFinder |
        CustomerFormQuestionTypes.BankAccount |
        CustomerFormQuestionTypes.FileUpload |
        CustomerFormQuestionTypes.DatePicker
      }
    />
  );
};
